module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-2c0b567c.png";